import {
	deleteOrderDelivery,
	getCreate,
	getOrdersDelivery,
	assignOrderDelivery,
	saveOrderDelivery,
	transformOrderDelivery,
} from "@/api/Purchases/orders_delivery";
import { useQuery, useMutation, useQueryClient } from "react-query";
import _ from "lodash";

const key = "purchase_orders_delivery";

export function useOrderDeliveryPaginate(params) {
	return useQuery([key, { ...params }], () => getOrdersDelivery(params));
}

export function useOrderDeliveryCreate(params) {
	return useQuery([key, { ...params }], () => getCreate(params));
}

export function useOrderDeliverySave(base, params) {
	const queryClient = useQueryClient();

	return useMutation(saveOrderDelivery, {
		onSuccess: (response) => {
			const list = _.omit(response, "order_delivery");
			const detail = response.order_delivery;

			queryClient.setQueryData([key, { ...base }], list);
			const query_data = { ...queryClient.getQueryData([key, { ...params }]) };

			queryClient.removeQueries(["purchase_orders_sale"]);

			if (detail) {
				query_data.order_delivery = detail;
				queryClient.setQueryData([key, { ...params }], query_data);
			}

			queryClient.removeQueries([key, { ...params }]);
			queryClient.removeQueries(["dashboard_valorization"]);
			queryClient.removeQueries(["dashboard_sales"]);
			queryClient.removeQueries(["dashboard_sales_dealer"]);
			queryClient.removeQueries(["pending-approval"]);
		},
	});
}

export function useOrderDeliveryDelete(base, params) {
	const queryClient = useQueryClient();

	return useMutation(deleteOrderDelivery, {
		onSuccess: (response) => {
			const list = _.omit(response, "order_delivery");
			const detail = response.order;

			queryClient.setQueryData([key, { ...base }], list);
			const query_data = { ...queryClient.getQueryData([key, { ...params }]) };

			if (detail) {
				query_data.order = detail;
				queryClient.setQueryData([key, { ...params }], query_data);
			}
		},
	});
}

export function useOrderDeliveryConfirmAssign(base) {
	const queryClient = useQueryClient();

	return useMutation(assignOrderDelivery, {
		onSuccess: (response) => {
			const list = _.omit(response, "order_delivery");
			queryClient.setQueryData([key, { ...base }], list);
		},
	});
}

export function useOrderDeliveryTransform(base, _params) {
	const queryClient = useQueryClient();

	return useMutation(transformOrderDelivery, {
		onSuccess: (_response) => {
			queryClient.invalidateQueries([key, { ...base }]);
		},
	});
}
